<template>
  <div
    class="alert"
    :class="[`alert-${type}`, { 'alert-dismissible': dismissible }]"
  >
    <slot />

    <button
      v-if="dismissible"
      type="button"
      class="close"
      aria-label="Close"
      @click="$emit('close')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      required: true,
      type: String
    },
    dismissible: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
